var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8a4 4 0 0 1 4-4h17v17a4 4 0 0 1-4 4H4V8Z",
    fill: "#985184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 35a4 4 0 0 1 4-4h11v11a4 4 0 0 1-4 4H4V35Z",
    fill: "#088BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h4a4 4 0 0 0 4-4V31h-4a4 4 0 0 0-4 4v11Z",
    fill: "#1AD3BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17v4a4 4 0 0 0 4 4h11v-4a4 4 0 0 0-4-4H31Z",
    fill: "#F9464C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 4v4a4 4 0 0 0 4 4h11V8a4 4 0 0 0-4-4H31Z",
    fill: "#FC868B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 46h4a4 4 0 0 0 4-4V31h-4a4 4 0 0 0-4 4v11Z",
    fill: "#03AF89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.b4bd5601a1ff1858f27367c80c152169.svg";
export { ForwardRef as ReactComponent };